var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { Component } from 'react';
import classNames from 'classnames';
import { defaultProps } from './defaults';
import { NewCascader } from '@feb-team/data-logic';
import { DivTag, LiTag, UlTag, SpanTag, InputTag } from '../../Utils/AtomicTag';
import { ArrowRightOutlined, ArrowDownOutlined, ArrowUpOutlined, LoadingOutlined, CheckMarkFunc, ClearOutlined, } from '@feb-team/legao-icons-react';
var getFieldNames = function (_a) {
    var fieldNames = _a.fieldNames;
    return fieldNames;
};
var getFilledFieldNames = function (props) {
    var fieldNames = getFieldNames(props) || {};
    var names = {
        children: fieldNames.children || 'children',
        label: fieldNames.label || 'label',
        value: fieldNames.value || 'value',
    };
    return names;
};
var highlightKeyword = function (str, keyword) {
    return str.split(keyword).map(function (node, index) {
        return index === 0
            ? node
            : [
                React.createElement(SpanTag, { atomics: "text-brand-600", className: "curr", key: index }, keyword),
                node,
            ];
    });
};
var defaultLimit = 50;
var defaultFilterOption = function (inputValue, path, names) {
    return path.some(function (option) { return option[names.label].indexOf(inputValue) > -1; });
};
var defaultRenderFilteredOption = function (inputValue, path, names) {
    return path.map(function (option, index) {
        var label = option[names.label];
        var node = label.indexOf(inputValue) > -1
            ? highlightKeyword(label, inputValue)
            : label;
        return index === 0 ? node : [' / ', node];
    });
};
var defaultSortFilteredOption = function (a, b, inputValue, names) {
    function callback(elem) {
        return elem[names.label].indexOf(inputValue) > -1;
    }
    return a.findIndex(callback) - b.findIndex(callback);
};
var Cascader = /** @class */ (function (_super) {
    __extends(Cascader, _super);
    function Cascader(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapper = React.createRef();
        _this.container = React.createRef();
        _this.handleClickOutside = function (e) {
            var el = _this.container.current;
            var boolWrap = _this.wrapper && _this.wrapper.current && _this.wrapper.current.contains(e.target);
            if (el && !el.contains(e.target) && !boolWrap) {
                if (e.nativeEvent) {
                    e.nativeEvent.stopImmediatePropagation();
                }
                if (_this.state.showPopper) {
                    _this.setState({
                        showPopper: false,
                        searchInput: '',
                    });
                }
            }
        };
        _this.renderColItem = function (itemList) {
            var _a = _this.props, loadData = _a.loadData, expandTrigger = _a.expandTrigger, disabled = _a.disabled;
            var liCls = [
                'flex',
                'items-center',
                'justify-between',
                'relative',
                'min-w-px-102',
                'max-w-px-168',
                'pl-4',
                'pr-3',
            ];
            var liList = itemList.map(function (item, index) {
                var _a;
                var isRoot = item.isRoot || (item.isLeaf === false && loadData);
                var setLiClsString = classNames((_a = {},
                    _a['text-brand-600 font-medium'] = item.curr,
                    _a['text-gray-600'] = !item.curr,
                    _a['text-gray-400 cursor-not-allowed'] = item.disabled || disabled,
                    _a['cursor-pointer hover:bg-gray-100'] = !item.disabled && !disabled,
                    _a));
                var setLiCls = setLiClsString.split(/\s/g);
                var liHtml = (React.createElement(LiTag, { atomics: __spread(liCls, setLiCls), key: index, onClick: expandTrigger === 'click' || (expandTrigger === 'hover' && !item.isRoot)
                        ? function (e) { return _this.handleItemEvent(item); }
                        : undefined, onMouseEnter: expandTrigger === 'hover' && item.isRoot ? function (e) { return _this.handleItemEvent(item); } : undefined },
                    React.createElement(SpanTag, { atomics: ['w-full', 'truncate'], className: "item-txt" }, item[_this.names.label]),
                    isRoot && !item.loading ? (React.createElement(SpanTag, { atomics: item.curr && !item.disabled
                            ? ['h-px-14', 'text-brand-600']
                            : ['h-px-14', 'text-gray-400'] },
                        React.createElement(ArrowRightOutlined, null))) : null,
                    !isRoot && item.curr ? (React.createElement(SpanTag, { atomics: ['text-base', 'h-px-14'] },
                        React.createElement(CheckMarkFunc, { className: "curr-icon" }))) : null,
                    item.loading ? React.createElement(LoadingOutlined, null) : null));
                return liHtml;
            });
            return React.createElement(React.Fragment, null, liList);
        };
        _this.renderCol = function () {
            var data = _this.state.showData;
            if (!data) {
                return null;
            }
            var ulCls = [
                'inline-block',
                'min-w-px-102',
                'max-w-px-168',
                'h-px-262',
                'overflow-y-auto',
                'border-gray-200',
            ];
            var UlList = data.map(function (item, index) {
                if (!item) {
                    return null;
                }
                var setUlCls = index > 0 ? 'border-l' : '';
                return (React.createElement(UlTag, { atomics: __spread(ulCls, [setUlCls]), className: 'cascader-level', key: index }, _this.renderColItem(item)));
            });
            return React.createElement(React.Fragment, null, UlList);
        };
        _this.handlePickerEvent = function () {
            if (!_this.props.disabled) {
                _this.setState({
                    showPopper: !_this.state.showPopper,
                });
            }
        };
        _this.handleItemEvent = function (item) {
            if (!item || item.disabled || _this.props.disabled) {
                return;
            }
            var _a = _this.props, loadData = _a.loadData, changeOnSelect = _a.changeOnSelect;
            var currActives = _this.entity.getActive(item);
            var cascaderData = currActives.showNode;
            var currNode = currActives.currNode;
            var activeValue = currNode.map(function (node) { return node[_this.names.label]; });
            var showPopper = _this.state.showPopper;
            // 叶子节点浮框需要隐藏
            showPopper = !item.isRoot && item.isLeaf !== false ? false : showPopper;
            var labelValue = changeOnSelect || !item.isRoot ? _this.getLabel(activeValue) : _this.state.labelValue;
            var isChanged = activeValue.toString() !== _this.state.activeValue.toString();
            _this.setState({
                showData: cascaderData,
                activeValue: activeValue,
                labelValue: labelValue,
                showPopper: showPopper,
            }, function () {
                if ((changeOnSelect || !item.isRoot) && isChanged) {
                    _this.setValue(activeValue, currNode);
                }
                if (item.isLeaf === false && !item[_this.names.children] && loadData) {
                    loadData(item);
                }
            });
        };
        _this.getShowData = function (activeValue) {
            var len = (activeValue === null || activeValue === void 0 ? void 0 : activeValue.length) || 0;
            if (activeValue && len > 0) {
                var showValue = activeValue.filter(function (v) { return _this.entity.getNodes(v, _this.names.label)[0]; });
                var sLen = (showValue === null || showValue === void 0 ? void 0 : showValue.length) || 0;
                if (sLen > 0) {
                    var lastNode = _this.entity.getNodes(showValue[sLen - 1], _this.names.label)[0];
                    return _this.entity.getActive(lastNode).showNode;
                }
                return _this.entity.getLevelData(1);
            }
            return _this.entity.getLevelData(1);
        };
        _this.setValue = function (value, selectedOptions) {
            if (selectedOptions === void 0) { selectedOptions = []; }
            var _a = _this.props, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange;
            if (onBeforeChange()) {
                onChange(value, selectedOptions);
            }
        };
        // 搜索
        _this.getFilteredOptions = function () {
            var showSearch = _this.props.showSearch;
            var names = _this.names;
            var _a = showSearch, _b = _a.filter, filter = _b === void 0 ? defaultFilterOption : _b, _c = _a.render, render = _c === void 0 ? defaultRenderFilteredOption : _c, _d = _a.sort, sort = _d === void 0 ? defaultSortFilteredOption : _d, _e = _a.limit, limit = _e === void 0 ? defaultLimit : _e;
            var searchInput = _this.state.searchInput;
            var flattenOptions = _this.entity.getLeaf();
            var filtered;
            if (flattenOptions) {
                if (limit > 0) {
                    filtered = [];
                    var matchCount_1 = 0;
                    flattenOptions.some(function (path) {
                        var match = filter(searchInput, path, names);
                        if (match) {
                            filtered.push(path);
                            matchCount_1 += 1;
                        }
                        return matchCount_1 >= limit;
                    });
                }
                else {
                    filtered = flattenOptions.filter(function (path) { return filter(searchInput, path, names); });
                }
                filtered.sort(function (a, b) { return sort(a, b, searchInput, names); });
                if (filtered.length > 0) {
                    return filtered.map(function (path) {
                        var _a;
                        return _a = {
                                path: path
                            },
                            _a[names.value] = path.map(function (o) { return o[names.value]; }),
                            _a[names.label] = render(searchInput, path, names),
                            _a.disabled = path.some(function (o) { return !!o.disabled; }),
                            _a.isEmptyNode = true,
                            _a;
                    });
                }
            }
            return null;
        };
        // 渲染搜索列表数据
        _this.renderSearchList = function () {
            var notFoundContent = _this.props.notFoundContent;
            var html = null;
            var filteredOptions = _this.getFilteredOptions();
            var sListCls = ['w-px-220', 'max-h-px-320', 'px-3', 'overflow-y-auto'];
            var emptyCls = [
                'text-center',
                'my-3',
                'text-sm',
                'h-px-22',
                'leading-px-22',
                'text-gray-400',
            ];
            if (!filteredOptions) {
                html = React.createElement(DivTag, { atomics: emptyCls }, notFoundContent);
            }
            else {
                var liHtml = filteredOptions.map(function (o, index) { return (React.createElement(DivTag, { atomics: ['w-full', 'cursor-pointer'], className: o.disabled ? 'disabled' : '', key: index, onClick: function () { return _this.handleSearchItemEvent(o); } }, o[_this.names.label])); });
                html = React.createElement(React.Fragment, null, liHtml);
            }
            return React.createElement(DivTag, { atomics: sListCls }, html);
        };
        // 处理搜索列表单条数据事件
        _this.handleSearchItemEvent = function (targetOption) {
            var _a = _this.props, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange, disabled = _a.disabled;
            if (!targetOption || targetOption.disabled || disabled) {
                return;
            }
            var activeValue = targetOption.path.map(function (o) { return o[_this.names.label]; });
            _this.setState({
                activeValue: activeValue,
                searchInput: '',
                labelValue: _this.getLabel(activeValue),
                showData: _this.getShowData(activeValue),
            });
            if (onBeforeChange()) {
                onChange(activeValue, targetOption.path);
            }
        };
        _this.handleInputBlur = function () {
            _this.setState({
                inputFocused: false,
            });
        };
        _this.handleInputClick = function (e) {
            var inputFocused = _this.state.inputFocused;
            if (inputFocused) {
                e.stopPropagation();
            }
        };
        _this.blurWrapEvent = function () {
            _this.setState({
                wrapFocus: false,
            });
        };
        _this.focusWrapEvent = function () {
            _this.setState({
                wrapFocus: true,
            });
        };
        _this.enterWrapEvent = function () {
            _this.setState({
                wrapHover: true,
            });
        };
        _this.leaveWrapEvent = function () {
            _this.setState({
                wrapHover: false,
            });
        };
        _this.handleInputChange = function (e) {
            var searchInput = e.target.value;
            _this.setState({ searchInput: searchInput });
        };
        _this.clearSelection = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                labelValue: '',
                activeValue: [],
                searchInput: '',
                showData: _this.getShowData([]),
            });
        };
        _this.names = getFilledFieldNames(props);
        _this.entity = NewCascader(props.data, 'tree', { childrenKeyName: _this.names.children });
        var initValue = props.value || props.defaultValue || [];
        _this.state = {
            activeValue: initValue,
            inputFocused: false,
            showData: _this.getShowData(initValue),
            searchInput: '',
            showPopper: props.showPopper,
            labelValue: _this.getLabel(initValue),
            wrapFocus: false,
            wrapHover: false,
        };
        return _this;
    }
    Cascader.prototype.componentWillReceiveProps = function (nextProps) {
        var newState = {};
        var _a = this.state, activeValue = _a.activeValue, showPopper = _a.showPopper, showData = _a.showData;
        if ('value' in nextProps) {
            newState.activeValue = nextProps.value;
        }
        if ('showPopper' in nextProps) {
            newState.showPopper = nextProps.showPopper;
        }
        if (nextProps.data && this.props.data !== nextProps.data) {
            this.entity = NewCascader(nextProps.data, 'tree', {
                childrenKeyName: this.names.children,
            });
            var initValue = nextProps.value || activeValue;
            newState.showData = this.getShowData(initValue);
        }
        if (newState.showData || newState.showData || 'showPopper' in newState) {
            this.setState({
                showData: newState.showData ? newState.showData : showData,
                showPopper: newState.showPopper ? newState.showPopper : showPopper,
                activeValue: newState.activeValue ? newState.activeValue : activeValue,
            });
        }
    };
    Cascader.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleClickOutside);
    };
    Cascader.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClickOutside);
    };
    Cascader.prototype.render = function () {
        var _a, _b, _c, _d, _e;
        var _f, _g, _h, _j, _k, _l, _m, _o;
        var _p = this.props, disabled = _p.disabled, showSearch = _p.showSearch, placeholder = _p.placeholder, size = _p.size, loadData = _p.loadData, onChange = _p.onChange, onBeforeChange = _p.onBeforeChange, fieldNames = _p.fieldNames, data = _p.data, defaultValue = _p.defaultValue, value = _p.value, displayRender = _p.displayRender, notFoundContent = _p.notFoundContent, changeOnSelect = _p.changeOnSelect, expandTrigger = _p.expandTrigger, propsShowPopper = _p.showPopper, rest = __rest(_p, ["disabled", "showSearch", "placeholder", "size", "loadData", "onChange", "onBeforeChange", "fieldNames", "data", "defaultValue", "value", "displayRender", "notFoundContent", "changeOnSelect", "expandTrigger", "showPopper"]);
        var _q = this.state, searchInput = _q.searchInput, showPopper = _q.showPopper, labelValue = _q.labelValue, wrapFocus = _q.wrapFocus, wrapHover = _q.wrapHover;
        var showSearchList = searchInput && showSearch;
        var list = showSearchList ? this.renderSearchList() : this.renderCol();
        var sizeMap = {
            small: {
                default: {
                    customKey: ['h-px-22', 'text-xs', 'leading-px-22'],
                },
            },
            normal: {
                default: {
                    customKey: ['h-px-32', 'text-sm', 'leading-px-30'],
                },
            },
            large: {
                default: {
                    customKey: ['h-px-40', 'text-base', 'leading-10'],
                },
            },
        };
        var pickerCls = [
            'relative',
            'inline-block',
            'box-border',
            'w-full',
            'rounded',
            'bg-white',
            'border',
            'overflow-hidden',
        ];
        var iconCls = [
            'absolute',
            'items-center',
            'w-px-32',
            'h-full',
            'justify-center',
            'cursor-pointer',
            'top-0',
            'right-0',
            'z-20',
        ];
        var labelCls = ['absolute', 'w-full', 'inline-block', 'truncate', 'px-3'];
        var inputCls = [
            'relative',
            'inline-block',
            'w-full',
            'bg-transparent',
            'px-3',
            'truncate',
        ];
        var setpickerClsString = classNames((_a = {},
            _a['border-brand-600'] = !disabled && (wrapFocus || wrapHover),
            _a['border-gray-200'] = !(wrapFocus || wrapHover),
            _a['text-gray-200 cursor-not-allowed opacity-60'] = disabled,
            _a['cursor-pointer'] = !disabled,
            _a));
        var setpickerCls = setpickerClsString.split(/\s/g);
        if (showPopper) {
            setpickerCls.push('shadow-input');
        }
        var setLabelCls = (!!searchInput ? 'text-transparent' : '');
        var setInputClsString = classNames((_g = (_f = sizeMap[size]) === null || _f === void 0 ? void 0 : _f.default) === null || _g === void 0 ? void 0 : _g.customKey, inputCls.join(' '), (_b = {},
            _b['text-gray-400 cursor-not-allowed'] = disabled,
            _b['cursor-pointer'] = !disabled,
            _b));
        var setInputCls = setInputClsString.split(/\s/g);
        var showClose = !showPopper && (!!labelValue || !!searchInput) && wrapHover;
        var setDownCls = classNames((_c = {},
            _c['hidden'] = !!showPopper || showClose,
            _c['flex'] = !showPopper && !showClose,
            _c));
        var setUpCls = classNames((_d = {},
            _d['hidden'] = !showPopper || showClose,
            _d['flex'] = !!showPopper && !showClose,
            _d));
        var setClearCls = classNames((_e = {},
            _e['flex'] = showClose,
            _e['hidden'] = !showClose,
            _e));
        return (React.createElement(DivTag, __assign({ name: Cascader.NAME, atomics: __spread(['relative', 'w-px-220', 'inline-block'], (_j = (_h = sizeMap[size]) === null || _h === void 0 ? void 0 : _h.default) === null || _j === void 0 ? void 0 : _j.customKey), ref: this.wrapper, onFocus: this.focusWrapEvent, onBlur: this.blurWrapEvent, onMouseEnter: this.enterWrapEvent, onMouseLeave: this.leaveWrapEvent }, rest),
            React.createElement(SpanTag, { atomics: __spread(pickerCls, (_l = (_k = sizeMap[size]) === null || _k === void 0 ? void 0 : _k.default) === null || _l === void 0 ? void 0 : _l.customKey, setpickerCls), onClick: this.handlePickerEvent, 
                // className="picker"
                autoPrefixedClassName: "cascader-picker" },
                React.createElement(SpanTag, { atomics: __spread(labelCls, (_o = (_m = sizeMap[size]) === null || _m === void 0 ? void 0 : _m.default) === null || _o === void 0 ? void 0 : _o.customKey, [setLabelCls]), autoPrefixedClassName: "cascader-picker-lable" }, labelValue),
                React.createElement(InputTag, { autoPrefixedClassName: "cascader-picker-input", atomics: setInputCls, tabIndex: -1, placeholder: labelValue ? undefined : placeholder, value: searchInput, disabled: disabled, readOnly: !showSearch, onClick: showSearch ? this.handleInputClick : undefined, onBlur: showSearch ? this.handleInputBlur : undefined, onChange: showSearch ? this.handleInputChange : undefined }),
                React.createElement(SpanTag, { atomics: __spread(iconCls, [setDownCls, 'text-gray-400']), autoPrefixedClassName: "cascader-picker-arrow-down" },
                    React.createElement(ArrowDownOutlined, null)),
                React.createElement(SpanTag, { atomics: __spread(iconCls, [setUpCls, 'text-brand-600']), autoPrefixedClassName: "cascader-picker-arrow-up" },
                    React.createElement(ArrowUpOutlined, null)),
                React.createElement(SpanTag, { atomics: __spread(iconCls, [setClearCls, 'text-base', 'text-gray-400']), onClick: this.clearSelection, autoPrefixedClassName: "cascader-picker-clear" },
                    React.createElement(ClearOutlined, null))),
            showPopper && (React.createElement(DivTag, { atomics: [
                    'absolute',
                    'left-0',
                    'z-30',
                    'flex',
                    'bg-white',
                    'rounded',
                    'border',
                    'border-gray-300',
                    'rounded',
                    'overflow-hidden',
                    'shadow-md',
                ], 
                // className="cascader-list"
                autoPrefixedClassName: "cascader-list", ref: this.container }, list))));
    };
    Cascader.prototype.getLabel = function (activeValue) {
        var displayRender = this.props.displayRender;
        var selectedOptions = this.entity.getNodes(activeValue.join(','), this.names.label);
        var label = activeValue;
        return displayRender(label, selectedOptions);
    };
    Cascader.defaultProps = defaultProps;
    Cascader.NAME = 'cascader';
    Cascader.displayName = 'Cascader';
    return Cascader;
}(Component));
export { Cascader };
